import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import type { DashboardFilter, DateRange } from '@/domain/repositories/dashboard.repository'

/**
 * Filter periode & outlet dashboard yang dibagi antar widget (KPI, chart, tabel).
 * Perubahannya otomatis memicu refetch di TanStack Query.
 */
export const useDashboardFilterStore = defineStore('dashboard-filter', () => {
  const range = ref<DateRange>('today')
  const selectedOutletId = ref<string | null>(null)
  const startDate = ref<string>('')
  const endDate = ref<string>('')

  const filter = computed<DashboardFilter>(() => ({
    period: range.value,
    startDate: range.value === 'custom' ? startDate.value : undefined,
    endDate: range.value === 'custom' ? endDate.value : undefined,
    outletId: selectedOutletId.value,
  }))

  function setRange(value: DateRange) {
    range.value = value
  }

  function setOutletId(outletId: string | null) {
    selectedOutletId.value = outletId === 'all' || !outletId ? null : outletId
  }

  function setCustomRange(start: string, end: string) {
    range.value = 'custom'
    startDate.value = start
    endDate.value = end
  }

  function resetFilter() {
    range.value = 'today'
    selectedOutletId.value = null
    startDate.value = ''
    endDate.value = ''
  }

  return {
    range,
    selectedOutletId,
    startDate,
    endDate,
    filter,
    setRange,
    setOutletId,
    setCustomRange,
    resetFilter,
  }
})
